module.exports = __webpack_public_path__ + "fonts/Mukta-300-latin6.e6837de.woff2";